import { createStore } from 'zustand';

import { CurrentUserQuery } from '../../generated/operation-ids';
import { get } from './graphql-fetch';
import { usePersistedQuery } from './use-persisted-query';

export const useCurrentUser = () => {
  const currentUser = usePersistedQuery(CurrentUserQuery);
  return {
    currentUser: {
      ...currentUser.data?.currentUser,
      uid: parseInt(currentUser.data?.currentUser?.uid || '0'),
      geoLocationAccess: currentUser.data?.geoLocationAccess,
      isLoading: currentUser.isLoading
    },
  };
};

type UserStore = {
  // The current user uid.
  uid: number;
  // Whether the user has access to the website from their current location.
  geoLocationAccess: boolean;
  // Fetch user information from the server and re-fresh the store.
  update: () => void;
};

export const currentUserStore = createStore<UserStore>((set) => ({
  uid: 0,
  geoLocationAccess: true,
  update: async () => {
    const currentUserResult = await get(CurrentUserQuery);
    set({
      uid: parseInt(currentUserResult.currentUser.uid || '0'),
      geoLocationAccess: currentUserResult.geoLocationAccess,
    });
  },
}));
